type TEnvironments = 'development' | 'production';

const useEnvironment = (): TEnvironments => {
  return `${process.env.GATSBY_ENVIRONMENT}` as TEnvironments;
};

export { useEnvironment };
